export const residential_real_estate = {
    meta_title: "Residential Fiber Network Solutions | GPON for Buildings",
    meta_description:
        "Niurix GPON residential solutions enable high-speed fiber connectivity for modern residential buildings and developments.",

    section1: {
        banner_img: "Residential real estate banner",
        banner_img_mobile: "Resident banner",
        title: "Reinventing Real-Estate Connectivity: Delivering Cutting Edge Fiber Solutions to Residential Spaces.",
    },
    section2: {
        img: "Residential REAL ESTATES1",
        title: "Solutions for <span>modern living</span> packed in <span>one box.</span>",
        subtitle: "Lorem_Subtitle",
        desc: "Experience the best possible connectivity in a seamless way and enjoy triple play services in the form of TV video, phone audio, and data. Once configured, leverage the power of harnessed data from anywhere in the building.",
    },

    section3: [
        {
            device_img: "ISP Router",
            device_title: "Router",
        },

        {
            device_img: "olt",
            device_title: "OLT",
        },

        {
            device_img: "Splitter",
            device_title: "Splitter",
        },

        {
            device_img: "Internet traffic",
            device_title: "Internet traffic",
        },

        {
            device_img: "1G Fiber",
            device_title: "1G Fiber",
        },

        {
            device_img: "Ethernet cable",
            device_title: "Ethernet cable",
        },

        {
            device_img: "ONT",
            device_title: "ONT",
        },

        {
            device_img: "IPTV",
            device_title: "IPTV",
        },

        {
            device_img: "Router",
            device_title: "Access Point",
        },

        {
            device_img: "telephone",
            device_title: "telephone",
        },

        {
            device_img: "wireless",
            device_title: "Wireless",
        },
    ],
    section4: {
        title: "Advantages of Niurix Residential Real-Estate Solutions",
        desc: "Leverage the power of FTTB (Fiber to the Building) networking solution with Niurix and elevate your real estate operations by delivering lightning-fast connectivity, smart building management, and enhanced resident experiences. Redefine modern living and upgrade your property to new heights.",
        cards: [
            {
                cards_img: "Resilient-and-Reliable",
                cards_title: "Resilient and Reliable",
                // cards_desc: "Consistent and high-speed connectivity even during peak usage with bandwidth-hungry applications.",
            },

            {
                cards_img: "Prepared for Tomorrow",
                cards_title: "Prepared for Tomorrow",
                // cards_desc: "Make your property in sync with future technologies and let Niurix handle future upgrades with ease.",
            },

            {
                cards_img: "Low-Latency",
                cards_title: "Low Latency",
                // cards_desc: "Experience transformational triple play services with minimum delay in data transfer for smooth entertainment.",
            },

            {
                cards_img: "Space-Efficient",
                cards_title: "Space Efficient",
                // cards_desc: "A sleek and modest design without the mesh of wires to compliment your space without making its presence known.",
            },
        ],
    },
    section5: {
        img: "contact banner",
        title: "Lorem",
    },
};
